__turbopack_context__.v({
  "className": "courgette_12dec9fe-module__--fklG__className",
});
